<div class="flex flex-row justify-start items-center gap-x-2">
  <p>
    <strong>Contact: </strong>
  </p>
  <div class="flex flex-col justify-start items-start">
    @if (contact$ | async; as contact) {
    <p class="m-0">
      {{ contact.full_name }}
    </p>
    @if (contact.contact_methods.length) {
    <p class="text-gray-500 text-sm m-0">
      {{ contact.contact_methods | contactMethodList }}
    </p>
    }
    } @else {
    <p>
      <em>No contact selected</em>
    </p>
    }
  </div>
  @if (!readonly) {
  <button mat-icon-button (click)="openSelectContactDialog()" matTooltip="Add / change contact">
    <mat-icon>edit</mat-icon>
  </button>
  }
</div>